import React from "react";
import { Modal, Button } from "react-bootstrap";

function FutureYearConfirmationModal({ 
  show, 
  onConfirm, 
  onCancel, 
  gradeLevel,
  academicYear,
  transitionWarning = null
}) {
  return (
    <Modal
      show={show}
      onHide={onCancel}
      centered
      size="lg"
      backdrop="static"
    >
      <Modal.Header closeButton style={{ borderBottom: 'none', paddingBottom: 0 }}>
        <Modal.Title style={{ 
          fontSize: '28px', 
          fontWeight: '700', 
          color: '#2c3e50',
          width: '100%',
          textAlign: 'center'
        }}>
          Create New {gradeLevel} Class - {academicYear}
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body style={{ padding: '30px 40px' }}>
        {/* Transition Warning - Only show if there are transitioning classes */}
        {transitionWarning && (
          <div style={{ 
            backgroundColor: '#fff9e6', 
            border: '1px solid #ffeaa7',
            borderRadius: '8px', 
            padding: '20px',
            marginBottom: '20px'
          }}>
            <p style={{ 
              fontSize: '16px', 
              fontWeight: '600', 
              color: '#856404',
              margin: 0,
              textAlign: 'center'
            }}>
              <strong>Important:</strong> Before creating a new {gradeLevel} class, please make sure this is brand new and not a class that is coming through from {transitionWarning.fromGradeName}. {transitionWarning.fromGradeName} classes will be converted to {transitionWarning.toGradeName} automatically during the Summer Holidays
            </p>
          </div>
        )}
        
        {/* Standard future year warning */}
        <div style={{ 
          backgroundColor: '#ffe6e6', 
          border: '1px solid #ffcccc',
          borderRadius: '8px', 
          padding: '20px',
        }}>
          <p style={{ 
            fontSize: '18px', 
            fontWeight: '600', 
            color: '#333',
            margin: 0,
            textAlign: 'center'
          }}>
            <strong>Important:</strong> Are you sure you want to create a class for next school year instead of this school year?
          </p>
        </div>
      </Modal.Body>
      
      <Modal.Footer style={{ 
        borderTop: 'none', 
        padding: '20px 40px 40px',
        justifyContent: 'space-between',
        gap: '20px'
      }}>
        <Button
          variant="outline-secondary"
          onClick={onCancel}
          style={{
            flex: '0 0 auto',
            minWidth: '150px',
            padding: '12px 30px',
            fontSize: '16px',
            fontWeight: '500',
            borderRadius: '6px',
            border: '2px solid #6c757d',
            color: '#6c757d'
          }}
        >
          Cancel
        </Button>
        
        <Button
          variant="primary"
          onClick={onConfirm}
          style={{
            flex: '1',
            padding: '12px 30px',
            fontSize: '16px',
            fontWeight: '500',
            borderRadius: '6px',
            backgroundColor: '#007bff',
            border: 'none'
          }}
        >
          Proceed with new {gradeLevel} class creation
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default FutureYearConfirmationModal;